import Decimal from 'decimal.js';
export class DecimalWrapper {
    value;
    constructor(value = 0) {
        if (value instanceof DecimalWrapper) {
            this.value = value.toDecimal();
        }
        else {
            this.value = new Decimal(value);
        }
    }
    toDecimal() {
        return this.value;
    }
    cmp(val) {
        return this.value.cmp(val);
    }
    toDecimalPlaces(decimalPlaces, rounding = 0) {
        return new DecimalWrapper(this.value.toDecimalPlaces(decimalPlaces, rounding));
    }
    minus(val) {
        const valueToSubtract = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.minus(valueToSubtract));
    }
    lessThan(val) {
        const valueToCompare = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return this.value.lessThan(valueToCompare);
    }
    times(val) {
        const valueToMultiply = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.times(valueToMultiply));
    }
    floor() {
        return new DecimalWrapper(this.value.floor());
    }
    ceil() {
        return new DecimalWrapper(this.value.ceil());
    }
    plus(val) {
        const valueToAdd = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.plus(valueToAdd));
    }
    pow(val) {
        const valueToPower = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.pow(valueToPower));
    }
    dividedBy(val) {
        const valueToDivide = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.dividedBy(valueToDivide));
    }
    toNumber() {
        return this.value.toNumber();
    }
    div(val) {
        const valueToDivide = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.div(valueToDivide));
    }
    mod(val) {
        const valueToMod = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return new DecimalWrapper(this.value.mod(valueToMod));
    }
    equals(val) {
        const valueToCompare = val instanceof DecimalWrapper ? val.toDecimal() : val;
        return this.value.equals(valueToCompare);
    }
    round() {
        return new DecimalWrapper(this.value.round());
    }
    logarithm() {
        return new DecimalWrapper(this.value.logarithm());
    }
    toString() {
        return this.value.toString();
    }
}
export const getDecimalValue = (val) => {
    return new DecimalWrapper(val);
};
//# sourceMappingURL=decimalWrapper.js.map